import styled from '@emotion/styled'

import { Slider, TextField } from '@mui/material';
import { BasicFlex } from '../Common';

const Container = styled.div`

`;

const SliderContainer = styled.div`
  padding: 0 1rem;
`;

const RangeSliderWithInput = ({ id, min = 0, max = 100000, step = 1000, value = {}, setRange, useFilter = false, handleChange }) => {

  let rangeObj = value;

  const changeHandler = (e, field) => {
    let val = e.target.value;
    if (!val) val = 0;
    handleChange({target: {value: val}}, id, field, "balance")
  }

  const sliderHandler = (e) => {
    let [start, end] = e
    handleChange({ $gte: start, $lte: end }, id);
  }

  let rangeValue = [rangeObj["$lte"] || 0, rangeObj["$gte"] || 0];

  return (
    <Container>
      <BasicFlex dir="row" justify="space-between" my="1rem">
        <TextField
          type="number"
          value={rangeObj["$gte"] || ""}
          onChange={(e) => changeHandler(e, "$gte")}
          placeholder={`More Than`}
          variant="outlined"
          size='small'
        />
        <TextField
          type="number"
          value={rangeObj["$lte"] || ""}
          onChange={(e) => changeHandler(e, "$lte")}
          placeholder={`Less Than`}
          size='small'
          variant="outlined"
        />
      </BasicFlex>
        <SliderContainer>
          <Slider
            value={rangeValue}
            onChange={(e, newValue) => sliderHandler(newValue)}
            min={min}
            max={max}
            step={step}
            valueLabelDisplay="auto"
            marks
            // marks={[{ value: min }, { value: max }]} // Add marks for the slider
          />
        </SliderContainer>
    </Container>
  );
};

export default RangeSliderWithInput;



